import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/fsd/og.png';
import type { BasePageConfig } from '../../BasePageConfig';

const productJsonld = {
  '@context': 'https://schema.org/',
  '@type': 'Product',
  name: 'Lemonade Autonomous Car Insurance: 50% Off Tesla FSD Miles',
  image: [ogImage.src],
  description:
    'Revolutionary Tesla FSD insurance from Lemonade: with half off FSD miles, seamless claims, full coverage options, and bundle savings. Easy and affordable from quote to claim.',
  brand: {
    '@type': 'Brand',
    name: 'Lemonade',
    logo: 'https://www.lemonade.com/assets/logo-e0f7c4f109ef5af2bb9604137856587ca61a56ed8c3ab2b8f56fcec923babafc.svg',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    ratingCount: '62818',
  },
  offers: {
    '@type': 'AggregateOffer',
    offerCount: '',
    lowPrice: '30',
    highPrice: '',
    priceCurrency: 'USD',
  },
};

export interface Config extends BasePageConfig {}

export const config: Config = {
  seo: {
    title: 'Lemonade Autonomous Car Insurance: 50% Off Tesla FSD Miles',
    metaTitle: 'Lemonade Autonomous Car Insurance: 50% Off Tesla FSD Miles',
    description:
      'Revolutionary Tesla FSD insurance from Lemonade: with half off FSD miles, seamless claims, full coverage options, and bundle savings. Easy and affordable from quote to claim.',
    ogImage: ogImage.src,
    advancedRobots: true,
    jsonld: [productJsonld],
  },
  layout: {
    ...sharedConfig['en-US'].layout,
    alignLogoOnMobile: 'left',
    headerActions: {
      ...sharedConfig['en-US'].layout.headerActions,
      CTAs: {
        ...sharedConfig['en-US'].layout.headerActions.CTAs,
        checkOurPrices: {
          ...sharedConfig['en-US'].layout.headerActions.CTAs.checkOurPrices,
          short: {
            singular: 'Check our price',
            plural: 'Check our prices',
          },
        },
      },
    },
  },
};

export const embedConfig = {
  ...config,
  seo: {
    ...config.seo,
    advancedRobots: true,
    noIndex: true,
  },
};
